export const methodology = {
  text: "Metodología",
  title1: "Nuestro enfoque",
  paragraph1:
    "A principios de 2016, el equipo de GDHM, junto con representantes de más de 20 países y más de 50 agencias y organizaciones internacionales, diseñaron la versión 1.0 del Global Digital Health Index (GDHI)." +
    " En 2022, el recurso se sometió a un proceso de revisión y rediseño de indicadores y plataformas de un año de duración para alinear los indicadores con la Estrategia mundial de salud digital de la OMS como complemento del Atlas de salud digital de la OMS e incluye un mayor enfoque en IA," +
    " equidad, género y Cobertura Universal de Salud. Además, el nombre se cambió a Global Digital Health Monitor (GDHM) para articular el valor de la herramienta al proporcionar una plataforma para monitorear el progreso de la salud digital a nivel nacional, regional y mundial." +
    " El GDHM actualizado incluye visualizaciones de país de monitoreo de desempeño año tras año, visualizaciones regionales y comparaciones de país a país.",
  bulletin: {
    title: "Para desarrollar los indicadores, el equipo de GDHM:",
    line1:
      "Condujo una revisión del panorama de los datos mundiales disponibles por medio de organizaciones multilaterales.",
    line2:
      "Mapeó los datos disponibles revisando los marcos y herramientas existentes desarrollados por expertos para ayudar a los " +
      "profesionales y a los países a evaluar la solidez y madurez del entorno propicio relevante para la salud digital.",
    line3:
      "Convocó a expertos en salud digital para desarrollar casos de uso de GDHM y refinar y definir un conjunto inicial de indicadores " +
      "recomendados en una lista fácil de usar y manejable.",
  },
  paragraph2: "Lista de indicadores GDHM - ",
  seeHere: "Vea aquí",

  title2: "Recolección y verificación de datos",
  paragraph3Start:
    "El equipo de GDHM trabaja con los socios nacionales y los representantes del Ministerio de Salud, que están liderando " +
    "los esfuerzos de salud digital en sus respectivos países para recopilar datos para cada país. Estos países socios presentan los datos " +
    "de su país a través de una encuesta anual de GDHM, y seleccionan la fase apropiada para cada indicador, así como la justificación y la " +
    "evidencia para apoyar estas fases. El equipo de GDHM verifica los datos recogidos antes de publicarlos. Se han incluido datos de salud " +
    "más amplios de los",
  paragraph3Link: "Indicadores de Desarrollo del Banco Mundial 2019",
  paragraph3End: "para contextualizar la madurez en salud digital.",

  title3: "Cálculo de promedios y análisis comparativo",
  paragraph4:
    "El GDHM utiliza los principales indicadores de cada categoría para calcular el promedio general del país. Si bien se incluyen " +
    "subindicadores para agregar mayor especificidad a los indicadores específicos de GDHM, no se utilizan para calcular la fase de componentes " +
    "ni los promedios nacionales o mundiales. El GDHM permite que los países se comparen con el Promedio Global o con una fase general específica.",
  title4: "Datos precargados de fuentes disponibles públicamente",
  paragraph5:
    "Para los países que no han completado una encuesta en Global Digital Health Monitor, los datos se extrajeron de la información disponible públicamente para completar previamente los indicadores a continuación para dar una idea general de la madurez del ecosistema digital más amplio en alineación con los indicadores relevantes. Si bien estos datos sirven como representación de estos indicadores de salud digital para los países, los datos completados por funcionarios gubernamentales brindan una imagen más precisa y sólida del progreso de la salud digital en cada país. Alentamos a los países que no han enviado datos completos a que soliciten un enlace de país para hacerlo lo antes posible.",
  indicators: {
    bulletin: {
      title:
        "Indicadores que utilizaron datos indirectos de fuentes disponibles públicamente para prepoblar países que no completaron una encuesta: ",
      line1:
        "Indicador 2a: La salud es una prioridad en las políticas nacionales de transformación digital y gobernanza de datos",
      line2:
        "Indicador 4: Análisis, planificación y seguimiento de la diversidad, la equidad y los derechos humanos incluidos en las estrategias y planes nacionales de salud digital",
      line3:
        "Indicador 6a: participación e inversiones del sector privado en salud digital",
      line4: "Indicador 7: marco legal para la protección de datos (seguridad)",
      line5:
        "Indicador 8: Leyes o Reglamentos de privacidad, consentimiento, confidencialidad y acceso a la información de salud (Privacidad)",
      line6:
        "Indicador 9: Protocolo para regular o certificar dispositivos y/o servicios de salud, incluidas disposiciones para IA y algoritmos (en etapas más altas de madurez)",
      line7: "Indicador 17: Preparación de la red",
      line8:
        "Indicador 18: Planificación y apoyo para el mantenimiento continuo de la infraestructura de salud digital",
    },
    paragraph: {
      start: "Las fuentes de datos incluyeron la ",
      govTech: "Indicador de madurez de GovTech",
      GTMI: "(GTMI)",
      NRI: "Índice de preparación de la red",
      GCI: "Índice de Ciberseguridad Global",
      GSMA: "Índice de conectividad móvil de GSMA",
      the: "el",
      andThe: "y el",
    },
  },
};
